export const IMGIX_DOMAIN = 'disco-1180.imgix.net'
export const IMGIX_ORIGIN = `https://${IMGIX_DOMAIN}`
